<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="12" class="text-center">
        <span class="title"
          >Experience
          <span class="caption text--secondary">({{ characterXP }})</span></span
        >
      </v-col>
      <v-row>
        <v-spacer />
        <v-col cols="12" md="6">
          <v-row justify="space-around" align="center">
            <v-checkbox
              class="my-0"
              v-for="xp in firstHalf"
              :key="xp"
              v-model="checked"
              :value="xp"
              :disabled="xp < characterXP || xp > (characterXP + 1)"
            />
          </v-row>

          <v-row justify="space-around" align="center">
            <v-checkbox
              class="my-0"
              v-for="xp in secondHalf"
              :key="xp"
              v-model="checked"
              :value="xp"
              :disabled="xp < characterXP || xp > (characterXP + 1)"
            />
          </v-row>
        </v-col>
        <v-spacer />
      </v-row>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" class="pa-0 ma-0">
        <BondTrack />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import BondTrack from '@/components/BondTrack.vue';
import _ from 'lodash'

  export default {
    name: 'Bonds',
    components: {BondTrack},
    data() {
      return {
        xps: [
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22,
          23,
          24,
          25,
          26,
          27,
          28,
          29,
          30,
        ],
        checked: [],
      };
    },
    created() {
      // Set up the 'checked' array based on current XP value
      for (var i = 0; i < this.characterXP; i++) {
        this.checked.push(this.xps[i]);
      }
    },
    watch: {
      checked() {
        this.$store.dispatch('character/setXP', _.max(this.checked));
      },
    },
    computed: {
      firstHalf() {
        return this.xps.slice(0, 15);
      },
      secondHalf() {
        return this.xps.slice(15, 30);
      },
      characterXP() {
        return this.$store.state.character.xp;
      },
    },
  };
</script>
